export const toQueryParams = params => {
  const formBody = []
  for (const property in params) {
    const value = params[property]
    if (value === undefined || value == null) {
      continue
    }
    const encodedKey = encodeURIComponent(property)
    const encodedValue = encodeURIComponent(value)
    formBody.push(encodedKey + '=' + encodedValue)
  }
  const result = formBody.join('&')
  return result
}

export async function fetchWithTimeout(resource, options) {
  let date = new Date().getTime()
  const timeout = options?.timeout || 60000

  const controller = new AbortController()
  const id = setTimeout(() => controller.abort(), timeout)

  try {
    const response = await fetch(resource, {
      ...options,
      signal: controller.signal,
    })

    if (response.status !== 200) throw new Error()

    clearTimeout(id)
    date = new Date().getTime() - date
    if (date > 1000) {
      console.log(
        'Request too slow, ' +
          date +
          ', resource: ' +
          resource +
          ', data: ' +
          JSON.stringify(options),
      )
    }

    return response
  } catch (error) {
    return error
  }
}

export function getQueryParams() {
  return parseQuery(window.location.search || '')
}

export function parseQuery(queryString) {
  let keyValPairs = []
  queryString = queryString.replace(/.*?\?/, '')

  const params = {}
  if (queryString.length) {
    keyValPairs = queryString.split('&')
    for (const pairNum in keyValPairs) {
      var key = keyValPairs[pairNum].split('=')[0]
      if (!key.length) continue
      params[key] = keyValPairs[pairNum].split('=')[1]
    }
  }
  return params
}
